import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiFailureText } from '@app/enum/alert-text.enum';
import { CodeValue } from '@app/models/code-value';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface CostCenterApiResponse {
  departmentCostCenterName: 'Sales - Canada';
  deptNbr: string;
  costCenterCode: string;
  costCenterHierarchies: string;
  createdUtc: string;
  lastUpdatedUtc: string;
}

@Injectable({ providedIn: 'root' })
export class CostCenterService {
  httpClient = inject(HttpClient);

  getCostCenters(searchTerm: string): Observable<CodeValue[]> {
    const costCenterUrl = `${environment.workdayIntegrationApi}/CostCenter`;
    const params = new HttpParams().set('search', searchTerm);

    return this.httpClient
      .get<CostCenterApiResponse[]>(costCenterUrl, { params })
      .pipe(
        map((response) => {
          return response.map(
            (r) =>
              new CodeValue(
                r.deptNbr,
                r.departmentCostCenterName,
                `${r.departmentCostCenterName} (${r.deptNbr})`,
              ),
          );
        }),
        catchError(() => {
          throw new Error(ApiFailureText.Generic);
        }),
      );
  }
}
